// eslint-disable-next-line
import Vue from 'vue'
import App from './App'
import jquery from 'jquery'
// import bootstrap from 'bootstrap'
// import easing from 'jquery.easing'

require('bootstrap/dist/js/bootstrap.bundle.js')
require('jquery.easing/jquery.easing.min.js')
// require('jquery.easing')

require('bootstrap/dist/css/bootstrap.css')
require('devicons/css/devicons.css')
require('font-awesome/css/font-awesome.css')
require('./assets/portafolio.css')

Vue.prototype.jquery = jquery

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js